import { tariffSummaryQueries } from 'products/tariffSummary/Inventory/queries/tariffSummaryQueries.ts';
import { useAtomValue } from 'jotai';
import {
  alertStatusTariffSummaryAtom,
  tariffSummaryPageFilterAtom,
  tariffSummaryRowsPerPageFilterAtom,
  tariffSummarySortingAtomWithStorage,
} from 'atoms/filters/tariff-summary.ts';
import { useTariffAccountRef } from 'products/tariffSummary/hooks/useTariffAccountRef.ts';

export const useTariffSummaryQueryKey = () => {
  const pageSize = useAtomValue(tariffSummaryRowsPerPageFilterAtom);
  const page = useAtomValue(tariffSummaryPageFilterAtom);

  const sorting = useAtomValue(tariffSummarySortingAtomWithStorage);
  const alertStatus = useAtomValue(alertStatusTariffSummaryAtom);
  const accountRef = useTariffAccountRef();

  return tariffSummaryQueries.list({
    pageSize,
    page,
    accountRef,
    sorting,
    alertStatus,
  });
};
